
export type GetDashboardStatisticsParams = {
period?: string;
};
